<template lang="pug"> 
  title-tab(:msg="$t('title.credit-report')")
    n-tap-01 
</template>
<script>
import NTap01 from '@/views/CreditReport/childs/P01' 
export default {
    components:{
        NTap01, 
    },  
}
</script>       